import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

import { Text, Location } from '@bizzabo/design-system';

interface LocationDetailsProps {
    physicalLocation?: string;
    isDisabled?: boolean;
}

const LocationDetails: React.FC<LocationDetailsProps> = ({
    physicalLocation,
    isDisabled,
    children,
}) => {
    const classes = useStyles();

    if (!physicalLocation && !children) {
        return null;
    }

    return (
        <div className={cn(classes.locationRow, { [classes.disabled]: isDisabled })}>
            <Location className={classes.locationIcon} title="location" />
            {physicalLocation && (
                <Text variant="t81" className={classes.locationText}>
                    {physicalLocation}
                </Text>
            )}
            {children}
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        locationRow: {
            position: 'relative',
            paddingLeft: 17,
            marginTop: 8,
        },
        locationIcon: {
            position: 'absolute',
            top: 2,
            left: 0,
        },
        locationText: {
            marginRight: 5,
            display: 'inline',
        },
        disabled: {
            opacity: 0.6,
        },
    }),
    { classNamePrefix: 'meetings-location-details' }
);

export default LocationDetails;
